<div class="container">
    <div class="spinner"></div>
</div>

